<template>
    <wrap class="d_wrap" ref="wrap" title="修改密码">
        <div class="input-wrap">
            <div class="update_password">

                <div class="input_wrap">
                    <label>
                        <span class="label">账户余额：</span>
                        <span class="text">
            <mark>{{0}}</mark>元
          </span>
                    </label>
                    <label>
                        <span class="label">可提现金额：</span>
                        <span class="text">
            <mark>{{0}}</mark>元
          </span> </label>
                    <label>
                        <span class="label">今天剩余提现次数：</span>
                        <span class="text">
            <mark>{{5}}</mark>次
          </span>
                    </label>

                    <label>
                        <span class="label">今天剩余提现次数：</span>
                        <select class="select">
                            <option>中国建设银行</option>
                            <option>中国建设银行</option>
                            <option>中国建设银行</option>
                        </select>
                    </label>


                    <label>
                        <span class="label">提现金额：</span>
                        <input type="text" placeholder="请输入您要提现的金额">
                    </label>

                    <label>
                        <span class="label">安全密码：</span>
                        <input type="text" placeholder="请输入您的安全密码">
                    </label>

                </div>

                <div class="submit">
                    <event tag="button" class="normal-btn t_btn-d active">确认</event>
                </div>
            </div>
        </div>

        <div class="table">
            <v-table :head="head" :body="body"></v-table>
        </div>

    </wrap>
</template>

<script>
  // qc15复用qc14
  import VTable from './table';
  import Wrap from "./wrap";
  import mixin from "./mixin";


  export default {
    name: "QC26",
    mixins: [mixin],
    components: {Wrap, VTable},
    computed: {
      head () {
        return this.data.head || [
          {label: '时间', value: 'time'},
          {label: '交易类型', value: 'type'},
          {label: '金额', value: 'money'},
          {label: '交易描述', value: 'desc'},
          {label: '单据状态', value: 'status'},
          {label: '订单号', value: 'order_num'},
        ];
      },
      body () {
        return this.data.body || [
          {
            time: '2019-07-02 11:12:23',
            type: '类型',
            money: 280,
            desc: '交易描述',
            status: '已提款',
            order_num: 'NO2019089078970809'
          },
          {
            time: '2019-07-02 11:12:23',
            type: '类型',
            money: 280,
            desc: '交易描述',
            status: '已提款',
            order_num: 'NO2019089078970809'
          },
          {
            time: '2019-07-02 11:12:23',
            type: '类型',
            money: 280,
            desc: '交易描述',
            status: '已提款',
            order_num: 'NO2019089078970809'
          },
          {
            time: '2019-07-02 11:12:23',
            type: '类型',
            money: 280,
            desc: '交易描述',
            status: '已提款',
            order_num: 'NO2019089078970809'
          },
          {
            time: '2019-07-02 11:12:23',
            type: '类型',
            money: 280,
            desc: '交易描述',
            status: '已提款',
            order_num: 'NO2019089078970809'
          }
        ];
      }
    },
    data() {
      return {};
    },
  }
</script>

<style lang="stylus" scoped>
    mark {
        color red !important
        font-weight bold
        background transparent
        margin-right 5px
    }

    .d_wrap {
        font-size 14px
        .dialog {
            height 700px
        }
        .input-wrap {
            width 100%
            text-align center
        }
        .update_password {
            display inline-block
            padding-bottom 15px
            .input_wrap {
                padding-right 54px
                > label {
                    display block
                    > .label {
                        display inline-block
                        width 140px
                        text-align right
                    }
                    > .text, > input {
                        width 200px
                        height 30px
                        line-height 30px
                        display inline-block
                        outline none
                        border 1px solid #e6e6e6
                        padding 0 10px
                    }
                }
                > label + label {
                    margin-top: 15px;
                }
            }
        }
        .submit {
            text-align center
            margin-top 15px
            > button {
                width 80px
                height 35px
                margin 0 5px
            }
        }
        .select {
            width 222px
            height 38px
            outline none
            padding-left 5px
            border 1px solid #e6e6e6
        }
    }

    .table {
        height 180px
        box-shadow 0 0 5px rgba(0, 0, 0, 0.1)
        overflow-y scroll
        overflow-x hidden
    }
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC26.vue